/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProgressCurveAnalysis } from './progressCurveAnalysis';

/**
 * Progress curve analytics
 */
export type StudentProgressReportProgressCurveAnalysis = ProgressCurveAnalysis | null;
